import { iconMap } from "../../utilities/utilities";

const ICON_TYPE_MAP = {
	Matter: "Matter",
	Document: "File",
	Email: "Email",
	"Matter Note": "Note",
};

export const contextItemIcon = (itemType, title, isFirmDocs = false) =>
	iconMap({
		original: {
			type: isFirmDocs ? "FirmDocs" : ICON_TYPE_MAP[itemType] || "File",
			filename: title,
		},
	}).iconComponent;
